module.exports = __webpack_public_path__ + "media/images/frontend/covid19_plasma-bbcb90eb7739521c852920aac656d932.svg";